import Control from 'ol/control/Control.js';

class ExtentSelectionControl extends Control {
  constructor(opt_options) {
    const options = opt_options ? opt_options : {};

    const button = document.createElement('button');
    button.addEventListener('click', () => {
      this.setActive(!this.active);
    });

    const element = document.createElement('div');
    element.className = 'extent-selection-control ol-unselectable ol-control';
    element.title = 'Etendre la sélection à la carte';
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    this.button = button;
    this.className = 'toggle fas fa-expand';
    this.setActive(options.active || false);
  }

  setActive(active) {
    this.button.className = this.className + (active ? ' active' : '');
    this.active = active;
  }
}

export default ExtentSelectionControl;
